import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
require('typeface-open-sans')
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js